import createHook from 'zustand';
import { postFeedback } from '@api/fetchers/goal/custom-doubts';

const useCustomDoubtsStore = createHook((set) => ({
  limitFlag: false,
  instantMatchFlag: false,
  isSubmitting: false,
  subjectSelectionFlow: {},
  submittedFeedbacks: {},
  selectedDoubtSolution: null,
  setSelectedDoubtSolution: (solutionUID) =>
    set((state) => {
      return {
        ...state,
        selectedDoubtSolution: solutionUID
      };
    }),
  setLimitFlag: (flagValue) =>
    set((state) => {
      return {
        ...state,
        limitFlag: flagValue
      };
    }),
  setInstantMatchFlag: (flagValue) =>
    set((state) => {
      return {
        ...state,
        instantMatchFlag: flagValue
      };
    }),
  updateSubjectSelectionFlow: (goalUID, doubtUID, selectionFlowState) =>
    set((state) => {
      return {
        ...state,
        subjectSelectionFlow: {
          ...state.subjectSelectionFlow,
          [goalUID]: {
            ...state.subjectSelectionFlow[goalUID],
            [doubtUID]: selectionFlowState
          }
        }
      };
    }),
  setSelectedFeedbackChoice: (uids) =>
    set((state) => {
      return {
        ...state,
        selectedfeedbackChoice: uids
      };
    }),
  setIsSubmitting: (isSubmitting) =>
    set((state) => {
      return {
        ...state,
        isSubmitting
      };
    }),
  submitFeedback: async (
    goalUID,
    doubtUID,
    solutionUID,
    selectedChoiceObj,
    description,
    feedbackType
  ) => {
    const body = {
      choice_uids: selectedChoiceObj,
      solution_uid: solutionUID,
      doubt_uid: doubtUID,
      description,
      goal_uid: goalUID
    };
    try {
      const response = await postFeedback(body);
      if (response.success) {
        set((state) => ({
          ...state,
          submittedFeedbacks: {
            ...state.submittedFeedbacks,
            [doubtUID]: {
              ...state.submittedFeedbacks[doubtUID],
              [solutionUID]: feedbackType
            }
          }
        }));
        return response;
      }
      return { success: false };
    } catch (error) {
      return { success: false };
    }
  }
}));

export default useCustomDoubtsStore;
